module.exports = __webpack_public_path__ + "static/media/icon-gender.4217f9ed.svg";